// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"task-checked"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 6V4H4V22H10M8 6H16M8 6V2H16V6M16 6V4H20V13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.7578 19.4144L16.5862 22.2428L22.2431 16.5859","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TaskCheckedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-checked',
    ref,
    icon: element,
  },
));

TaskCheckedIcon.displayName = 'TaskCheckedIcon';

export default TaskCheckedIcon;
